import React from 'react';
import * as Styles from './membership.styles';


export const Membership: React.FC = () => {
    return (
      <Styles.MembershipContainer>
        <Styles.Section>
          <Styles.Heading>Membership Applications</Styles.Heading>
          <Styles.Text>
            We are excited to welcome passionate individuals to the King's Rust Group! 
            To maintain a fast pace of development and learning, we have limited spaces, 
            which is why we require an application process. Our goal is to ensure that 
            all members are committed and capable of contributing to the group’s mission 
            of advancing Rust programming knowledge and practice.
          </Styles.Text>
        </Styles.Section>
  
        <Styles.Section>
          <Styles.Heading>King's Students</Styles.Heading>
          <Styles.Text>
            As we meet at King’s College London and utilize its resources, students 
            currently enrolled at King’s College will automatically be approved for membership. 
            This ensures that King’s students can take full advantage of the opportunities 
            we provide for growth and collaboration.
          </Styles.Text>
        </Styles.Section>
  
        <Styles.Section>
          <Styles.Heading>Rust Experience</Styles.Heading>
          <Styles.Text>
            Applicants with professional Rust programming experience will be highly valued, 
            as this demonstrates their ability to contribute to projects effectively. 
            If an applicant lacks strong academic achievements, substantial Rust experience 
            can compensate and showcase their expertise in the language.
          </Styles.Text>
        </Styles.Section>
  
        <Styles.Section>
          <Styles.Heading>Academic Achievements</Styles.Heading>
          <Styles.Text>
            Strong academic achievements can make up for a lack of professional Rust experience. 
            These achievements indicate the ability to learn quickly and adapt to the rigorous 
            pace of our group’s development cycle. Applicants with relevant educational 
            backgrounds will find this an advantageous factor in their application.
          </Styles.Text>
        </Styles.Section>
  
        <Styles.ApplyButton
          href="https://forms.gle/k36TZbjt2EfMsgdA6"
          target="_blank"
          rel="noopener noreferrer"
        >
          Apply Here
        </Styles.ApplyButton>
      </Styles.MembershipContainer>
    );
  };